import { useContext } from 'react';

import PageContext from '../../Context/PageContext';
import SketchColor from './SketchColor';
import { display } from '@xuannghia/html2canvas/dist/types/css/property-descriptors/display';

const ElevationColorPicker = () => {
  const { elevationData } = useContext(PageContext);

  return (
    <div className="text-picker">
      <div style={{ display: 'flex' }}>
        <div className="label-side-menu">Couleur </div>
        <SketchColor elem={'elevation-bg'} color={(elevationData != null) ? elevationData.datasets[0].backgroundColor : '#000000'} />
      </div>

      <div style={{ display: 'flex' }}>
        <div className="label-side-menu">Bordure </div>
        <SketchColor elem={'elevation-bordure'} color={(elevationData != null) ? elevationData.datasets[0].borderColor : '#000000'} />


      </div>
    </div>
  );

};

export default ElevationColorPicker;